export const StripeRedirectProductKey = 'StripeRedirectProductKey';
export const StripeRedirectKey = 'stripeRedirectKey';
export const StripeRedirectUpdatePaymentMethod = 'updatePaymentMethod';
export const StripeRedirectCreateSubscription = 'createSubscription';
export const StripeRedirectPromotionCode = 'StripeRedirectPromotionCode';
